import React from 'react';
export function usePassword(state, props) {
    var isLoading = state.isLoading, isReadonly = state.isReadonly, isDisabled = state.isDisabled;
    var password = props.password, passwordVisible = props.passwordVisible, onPasswordVisible = props.onPasswordVisible;
    var _a = React.useState(passwordVisible || false), visible = _a[0], setVisible = _a[1];
    function toggle() {
        setVisible(!visible);
        onPasswordVisible && onPasswordVisible(!visible);
    }
    function enable() {
        return Boolean(!isDisabled() &&
            !isReadonly());
    }
    function show() {
        return Boolean(password &&
            !isLoading());
    }
    return {
        visible: visible,
        toggle: toggle,
        enable: enable(),
        show: show(),
    };
}
